import React from "react";
import { DashboardEmptyState, HubTableTemplate } from "../../components";

const items = [
  { id: "poNumber", label: "PO #" },
  { id: "customer", label: "Customer" },
  { id: "revenue", label: "Revenue" },
  { id: "createdAt", label: "Created" },
  { id: "createdBy", label: "Created By" },
];

const keys = [
  {
    variant: "blueBold",
    value: "poNumber",
    navigate: true,
    route: "orders",
    id: "id",
  },
  { value: "customer.name", defaultValue: "—" },
  { value: "revenue", isCurrency: true },
  { value: "createdAt", isDate: true },
  { value: "createdBy", isUser: true, userProps: { size: "18px" } },
];

export const RecentOrdersTable = ({ rows = [], isLoading }) => {
  if (!isLoading && !rows.length) {
    return (
      <DashboardEmptyState
        icon="ShoppingCart"
        title="No recent orders"
        subtitle="New purchase orders will show up here as they're created."
      />
    );
  }
  return (
    <HubTableTemplate
      id="dashboard-recent-orders"
      headerProps={{ items }}
      bodyProps={{ items: rows, keys }}
      isLoading={isLoading}
    />
  );
};

export default RecentOrdersTable;
